import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";

/**
 * Uygulama açılışında player hangi duruma alınmalı.
 *
 * Bu uygulama BOTTUR: gece senkronunda görevleri sunucu üretiyor ve bot yalnız
 * Electron açıkken koşuyor. Hedef "uygulamayı aç, gerisine karışma" olduğu için,
 * kullanıcı otomatik oynatmayı açık bıraktıysa açılışta beklemeye (oto) geçilir.
 *
 * Eskiden `App.vue` açılışta KOŞULSUZ `emit('player', dur)` yapıyordu; tercih
 * açık olsa bile bot her açılışta duruyor ve elle "Başlat" gerekiyordu.
 *
 * Saf tutuldu ki bileşen mount etmeden test edilebilsin — repodaki tüm spec'ler
 * bu deseni kullanıyor (mount/shallowMount yok).
 */
export function acilisPlayerDurumu(autoPlay: boolean): PlayerDurum {
    return autoPlay === true ? PlayerDurum.oto : PlayerDurum.dur;
}
